import { useEffect } from 'react';

interface PageMeta {
  title?: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function usePageMeta(meta: PageMeta) {
  useEffect(() => {
    const base = '漫画免费全集目录聚合';
    if (meta.title) {
      document.title = `${meta.title} - 漫画免费站`;
    } else {
      document.title = '漫画免费全集目录聚合 | 漫画免费全本资源打包看';
    }
    if (meta.description) setMeta('description', meta.description);
    if (meta.keywords) setMeta('keywords', meta.keywords);
    return () => {
      document.title = base;
    };
  }, [meta.title, meta.description, meta.keywords]);
}